import toast from "react-hot-toast";
import { ApiResponse } from "../api/apiResponse";

export class ErrorService {
  static handleApiErrors(response: ApiResponse) {
    this.handleErrorMessages(response.errorMessages || []);
  }

  static handleErrorMessages(errorMessages: string[]) {
    errorMessages.forEach((error: any) => {
      toast.error(error);
    });
  }
}
